export const type = 'hideModalLoading';

const hideModalLoading = (accion) => ({
    type,
    payload: new Date(),
    accion:accion,
});

export default hideModalLoading;